/** Text the voice layer is allowed to speak — never raw JSON / agent_config. */

export function extractSpokenText(raw: string): string {
  const trimmed = (raw || '').trim();
  if (!trimmed) return '';

  if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
    try {
      const data = JSON.parse(trimmed) as Record<string, unknown>;
      if (data && typeof data === 'object') {
        const value = data.message;
        if (typeof value === 'string' && value.trim()) {
          return stripMarkdown(value);
        }
        return '';
      }
    } catch {
      return stripMarkdown(trimmed);
    }
  }

  return stripMarkdown(trimmed);
}

function stripMarkdown(text: string): string {
  let out = text;
  out = out.replace(/```[\s\S]*?```/g, '');
  out = out.replace(/`[^`]+`/g, '');
  out = out.replace(/https?:\/\/\S+/g, '');
  out = out.replace(/^#{1,6}\s+/gm, '');
  out = out.replace(/\*\*([^*]+)\*\*/g, '$1');
  out = out.replace(/\*([^*]+)\*/g, '$1');
  out = out.replace(/\s+/g, ' ');
  return out.trim();
}
